import {getFixedT} from 'i18next'

// Define the type for romeToJobCodeMapping
type RomeToNameMap = {
  [key: string]: string
}

// Define the mapping of romeId to jobCode.
const romeToNameMapping: RomeToNameMap = {
  A1201: 'Elagueur',
  A1203: 'Paysagiste',
  A1301: 'Agricole',
  A1404: 'aquaculture',
  A1407: 'éleveur bovin',
  A1410: 'Berger',
  A1414: 'Maraîcher',
  A1416: 'Agricole',
  C1502: 'immobilier',
  D1101: 'boucher',
  D1102: 'boulanger',
  D1103: 'charcutier',
  D1104: 'pâtissier',
  D1105: 'poissonnier',
  D1202: 'Coiffeur',
  D1208: 'esthéticien',
  D1213: 'vendeur',
  D1401: 'forces de vente',
  D1402: 'grands comptes',
  D1403: 'forces de vente',
  D1404: 'forces de vente',
  D1406: 'forces de vente',
  D1407: 'Technico-commercial',
  D1502: 'rayon',
  F1102: 'décorateur',
  F1103: 'dignostiqueur',
  F1104: 'Dessinateur',
  F1106: 'BIM',
  F1108: 'construction',
  F1201: 'BTP',
  F1202: 'BTP',
  F1203: 'ingénieur',
  F1204: 'environnement',
  F1301: 'BTP',
  F1302: 'BTP',
  F1401: 'forage',
  F1402: 'carrière',
  F1501: 'Charpente',
  F1502: 'structures métalliques',
  F1503: 'Charpentier',
  F1601: 'plâtrier',
  F1602: 'Electricien',
  F1603: 'Chauffagiste',
  F1604: 'plaquiste',
  F1605: 'Electricien',
  F1606: 'Peinture',
  F1607: 'Vitrier',
  F1608: 'Carreleur',
  F1609: 'moquettiste',
  F1610: 'couvreur-zingueur',
  F1611: 'façadier',
  F1613: 'travaux publics',
  F1701: 'béton industriel',
  F1702: 'paveur',
  F1703: 'Maçon',
  F1704: 'travaux publics',
  F1706: 'béton industriel',
  G1203: 'Animateur',
  G1601: 'cuisinier',
  G1602: 'cuisine',
  G1603: 'restauration',
  G1605: 'cuisinier',
  G1801: 'restauration',
  G1802: 'restauration',
  G1803: 'restauration',
  G1804: 'restauration',
  H1101: 'support',
  H1203: 'Dessinateur',
  H1206: 'industriel',
  H1208: 'automaticien',
  H1402: 'industralisation',
  H1404: 'méthodes',
  H1501: 'laboratoire',
  H1502: 'laboratoire',
  H1503: 'laboratoire',
  H1504: 'électronique',
  H1505: 'laboratoire',
  H1506: 'qualité',
  H2101: 'boucher',
  H2102: 'alimentaire',
  H2202: 'agro-alimentaire',
  H2206: 'Menuisier',
  H2301: 'industrie',
  H2401: 'industrie',
  H2402: 'textile',
  H2404: 'textile',
  H2405: 'textile',
  H2406: 'textile',
  H2407: 'textile',
  H2408: 'textile',
  H2409: 'textile',
  H2410: 'textile',
  H2411: 'textile',
  H2412: 'textile',
  H2413: 'textile',
  H2414: 'textile',
  H2415: 'textile',
  H2501: 'industrie',
  H2502: 'atelier',
  H2503: 'industrie',
  H2504: 'industrie',
  H2505: 'industrie',
  H2601: 'bobinier',
  H2602: 'électricien',
  H2603: 'électronique',
  H2604: 'électricien',
  H2605: 'électronique',
  H2701: 'énergie',
  H2801: 'fibre de verre',
  H2802: 'construction',
  H2803: 'industrie céramique',
  H2804: 'béton industriel',
  H2805: 'industrie du verre',
  H2901: 'mécanique',
  H2902: 'Chaudronnier',
  H2903: 'Usinage',
  H2904: 'métallurgie',
  H2905: 'métallurgie',
  H2906: 'métallurgie',
  H2907: 'métallurgie',
  H2908: 'modelage',
  H2909: 'mécanique',
  H2910: 'moulage',
  H2911: 'structures métalliques',
  H2912: 'régleur',
  H2913: 'soudeur',
  H2914: 'tuyauteur',
  H3101: 'papier carton',
  H3102: 'papier carton',
  H3301: 'emballage',
  H3302: 'emballage',
  H3303: 'industrie ',
  H3401: 'traitement de surfaces',
  H3402: 'traitement de surfaces',
  H3403: 'traitement thermique',
  H3404: 'peinture industrielle',
  I1301: 'maintenance',
  I1302: 'maintenance',
  I1303: 'maintenance',
  I1304: 'maintenance industrielle',
  I1305: 'maintenance électronique',
  I1306: 'frigoriste',
  I1307: 'Courant',
  I1308: 'maintenance',
  I1309: 'maintenance',
  I1310: 'mécanique',
  I1401: 'informatique',
  I1402: 'réparateur',
  I1604: 'mécanicien',
  I1606: 'carrossier',
  I1607: 'cycles',
  J1301: 'agent hôtelier hospitalier',
  J1304: 'auxiliaire de puériculture',
  J1306: 'imagerie médicale',
  J1405: 'Opticien',
  J1501: 'aide-soignant',
  J1502: 'cadre santé',
  J1506: 'infirmier',
  K1102: 'mandataire',
  K1202: 'éducateur',
  K1207: 'socio-éducatif',
  K1301: 'éducatif',
  K1302: 'auxiliaire de vie',
  K1303: 'auxiliaire de vie',
  K1304: 'aide à domicile',
  K1403: 'management santé',
  K2201: 'propreté industrielle',
  K2203: 'Entretien locaux',
  K2204: 'Entretien propreté',
  K2301: 'assainissement',
  K2304: 'déchets',
  K2305: 'revalorisation déchets',
  K2306: 'revalorisation déchets',
  K2402: 'chercheur',
  K2502: 'sécurité suveillance',
  K2503: 'agent de sécurité',
  K2601: 'funéraire',
  K2602: 'funéraire',
  M1101: 'achat',
  M1203: 'Comptable',
  M1403: 'data',
  M1609: 'secrétaire',
  M1801: 'administrateur réseaux',
  M1802: 'Ingénieur informatique',
  M1803: 'Directeur des systèmes information',
  M1804: 'réseau télécom',
  M1805: 'développeur',
  M1806: 'système information',
  M1810: 'système information',
  N1101: 'magasinier',
  N1102: 'déménageur',
  N1103: 'magasinier',
  N1104: 'magasinier',
  N1105: 'agent de quai',
  N1201: 'affrêteur',
  N1202: 'logistique',
  N1301: 'logistique',
  N1302: 'logistique',
  N1303: 'Logistique',
  N4101: 'poids-lourds',
  N4103: 'Transport',
  N4201: 'messagerie',
  N4203: 'Logistique',
  N4204: 'Transport voyageurs',
  // ... add other mappings as needed.
}

// TODO(cyrille): Use this for CPF too.
export default (job: ValidUpskillingJob, city: bayes.bob.FrenchCity): Promise<string> => {
  const interpolate = getFixedT(config.defaultLang)
  const {jobGroup: {
    romeId,
    samples: [{name: jobName = '', masculineName: jobMasculineName = ''} = {}] = [],
  } = {}} = job

  // Retrieve jobCode from the mapping using romeId.
  const nameCode = romeId && romeToNameMapping[romeId]

  const {cityId, departementId, latitude, longitude, name: cityName = ''} = city

  const profileLinkTemplate = 'https://app.explorjob.com/#/search/results?jobLabel={{nameCode}}'

  // i18next-extract-disable-next-line
  return Promise.resolve(interpolate(profileLinkTemplate, {
    cityId,
    cityName: encodeURIComponent(cityName),
    departementId,
    jobName: encodeURIComponent(jobMasculineName || jobName),
    latitude,
    longitude,
    nameCode,
    romeId,
  }))
}
